import { render, staticRenderFns } from "./InputScope.vue?vue&type=template&id=58c23c36"
import script from "./InputScope.vue?vue&type=script&lang=js"
export * from "./InputScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports